/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * user: what the admin wrote. assistant: what the agent said. tool: a tool the agent called.
 */
export enum AgentMessageRole {
  user = 'user',
  assistant = 'assistant',
  tool = 'tool'
}
